// frontend/src/shared/hooks/i18n/useI18n.ts
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserLanguage } from '../../../contexts/UserContext'; // ✅ Usar contexto
import { Language } from '../../../types/common.types';

interface UseI18nReturn {
	t: any;
	i18n: any;
	language: Language | null;
	languageError: string | null;
}

function useI18n(): UseI18nReturn {
	const { language, error: languageError } = useUserLanguage();
	const { t, i18n } = useTranslation();

	useEffect(() => {
		if (language && i18n.language !== language) {
			i18n.changeLanguage(language).catch(() => {
				// Error de cambio de idioma manejado silenciosamente
			});
		}
	}, [language, i18n]);

	return {
		t,
		i18n,
		language,
		languageError,
	};
}

export default useI18n;
